import {NativeModules} from 'react-native';
export default NativeModules.AndroidVolumeControlModule;
export const KEY_CODES = {
  VOLUME_DOWN: 25,
  VOLUME_UP: 24
};
